import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Output,
	ViewEncapsulation
} from '@angular/core';

@Component({
	selector: 'a-overlay',
	standalone: true,
	template: `<div class="a-overlay" (click)="click($event)"></div>`,
	styleUrls: ['../../../styles/6-atoms/_overlay.scss'],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [CommonModule],
	providers: []
})
export class OverlayComponent {
	@Output() clicked = new EventEmitter<void>();

	protected click(event: Event): void {
		event.preventDefault();
		event.stopPropagation();
		this.clicked.emit();
	}
}
